<template>
    <div>
        <v-card class="mx-auto normal-card">
            <div class="data-table-section prev-test-tb cat-44">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onSortChange="onSortChange"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td
                                    class="rescheduletest"
                                    @click="gotoPastTest(item)"
                                >
                                <v-tooltip left content-class="cust-new-tooltip-bottom">
                                    <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        {{ item.test_name }}
                                    </div>
                                    </template>
                                    <span>
                                    <b> Target Exam: </b> {{ item.target_name ? item.target_name : "Custom" }} <br/>
                                    <b>Test Pattern: </b> {{ item.omr_pattern_id ? OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                                    </span>
                                </v-tooltip>
                                </td>
                                <td class="duration-display">{{item.duration}}</td>
                                <td class="text-center">{{item.target_name}}</td>
                                <td class="text-center">
                                    <div class="date-ui">{{ getFormatedDate(item.date_answered) }}</div>
                                    <!-- <div class="time-ui">{{ getFormatedTime(item.date_answered) }}</div> -->
                                </td>
                                <td class="text-center">{{item.your_marks}}</td>
                                <td class="text-center">{{item.batch_rank}}</td>
                                <td class="text-center">
                                <span style="color: blue;" v-if="item.is_shared_test">
                                    AITS
                                </span>
                                </td>
                                <td class="text-center">{{item.institute_rank}}</td>
                                <td class="text-center">{{item.highest_mark}}</td>
                                <td class="text-center">{{item.avg_mark || '--'}}</td>
                                
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div class="btm-test-prev-test d-flex justify-space-between ">  
                <div style="color: blue;" class="ml-2">Blue coloured tests are conducted by A.I.T.S</div>
                 <div>Click on a test name to revisit that test</div></div>
                </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
    name: "InstituteTest",
    mounted() {
        this.defaultData();
        this.OMR_PATTERN = constants.OMR_PATTERN;
    },
    data() {
        return {
            headers: [
                {
                    text: "Test Name",
                    value: "alt_test_name",
                    hideSort: true
                },
                {
                    text: "Duration\n(Min)",
                    value: "duration",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Target Exam",
                    value: "target_exam",
                    class: "text-center",
                    type: "multidropdown",
                    options: [],
                    allText: "All Target Exams"
                },
                {
                    text: "Date Answered",
                    value: "date_answered",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Your Marks",
                    value: "your_marks",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Batch Rank",
                    value: "batch_rank",
                    class: "text-center"
                },
                {
                    text: "Test Type",
                    value: "status",
                    class: "text-center",
                    hideSort: true,
                },
                {
                    text: "Institute Rank",
                    value: "institute_rank",
                    class: "text-center"
                },
                {
                    text: "Highest Marks",
                    value: "highest_mark",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Average Marks",
                    value: "avg_mark",
                    class: "text-center",
                    hideSort: true
                }
            ],
            items: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            orderBy: {
                field: "started",
                order: "DESC"
            },
            selectedExamTypes: []
        };
    },
    methods: {
        ...mapActions({
            getTestTarget: "utilStore/getTestTarget",
            getPastTestList: "testStore/getPastTestList"
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.selectedExamTypes = crd.tabDetails[crd.selectedTab].examTypes;
            }
            this.reqGetTestTargets();
            this.requestGetTestList();
        },
        getFormatedDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        getFormatedTime(date) {
            return moment(date).format("hh:mm A");
        },
        reqGetTestTargets() {
            this.getTestTarget({})
                .then(response => {
                    // this.loading = false;
                    this.headers[2].options = response.map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = this.selectedExamTypes.includes(x.id);
                        return c;
                    });
                })
                .catch(err => {
                    this.$toasted.error('Error getting exam types');
                    this.loading = false;
                });
        },
        gotoPastTest(item) {
            let test_institute_id = item.test_institute_id;
            this.$router.push({
                name: "past-test-details",
                params: {
                    test_id: item.id,
                    test_institute_id
                }
            });
        },
        requestGetTestList() {
            let reqData = {
                type: "INSTITUTE",
                // test_types: [this.TEST_TYPE.PAST_TEST],
                target_ids: this.selectedExamTypes,
                orderBy: this.orderBy,
                test_name: null,
                pagination: { page: this.currentPage, pageSize: this.pageSize }
            };
            this.$root.showLoader = true;
            this.getPastTestList(reqData)
                .then(response => {
                    if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    } 
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.totalPages = response.pagination.pageCount;
                    const sharedTestIds = this.items
                    .filter(item => item.is_shared_test === 1)
                    .map(item => ({ id: item.id, is_shared_test: item.is_shared_test }));
                    localStorage.setItem('sharedTestIds', JSON.stringify(sharedTestIds));
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onHeaderAction(e) {
            if (e.data && e.data.selectedItems) {
                this.selectedExamTypes = e.data.selectedItems;
                let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
                this.setRouteDetails(crd);
                this.onPageChange(1);
            }
        }
    }
};
</script>